import React from 'react';
import properties from '../../constants/Properties';
import locales from '../../locales/LocalesManager';
import { showZoomSlides } from '../../actions/MenuActions';
import { updateHospot, updateCurrentSlideThumbnail } from '../../actions/CurrentSlideActions';
import mouseUtils from '../../components/utils/MouseUtils';
import zoomUtils from '../../components/utils/ZoomUtils';
import { updateCurrentSlide } from '../../actions/ProductionActions';
import storeManager from '../../store/StoreManager';
import { connect } from 'react-redux';
import saveManager from '../utils/SaveManager';
import apiServiceUtils from '../utils/ApiServiceUtils';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import platformDetection from "../utils/PlatformDetection";

const Title = React.createClass({
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        const titleStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_SELECTED_COLOR,
            width: this.props.accordionWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 20,
            top: 0
        };

        const spanStyle = {
            color: 'white',
            fontSize: 16,
            cursor: 'default',
            position: 'absolute',
            top: 6
        };

        return (
            <div style={titleStyle}>
                <span style={spanStyle}>{locales.getCaption('Title', 'zoom')}</span>
            </div>
        );
    }
});

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        switch (this.props.index) {
            case 0: { // ZOOM
                this.props.dispatch(updateHospot(zoomUtils.currentBackgroundUid, zoomUtils.currentHotspot));
                audioEditorUtils.addActionToHistory();
                this.props.dispatch(updateCurrentSlide());
                this.props.dispatch(updateCurrentSlideThumbnail(true));
                this.props.dispatch(showZoomSlides(false));
                saveManager.isContentChanged(true);
                break;
            }

            case 1: { // RESET ZOOM
                if (this.isResetEnabled() == true) {
                    saveManager.isContentChanged(true);
                    this.props.dispatch(updateHospot(zoomUtils.currentBackgroundUid, ''));
                    audioEditorUtils.addActionToHistory();
                    this.props.dispatch(updateCurrentSlide());
                    this.props.dispatch(updateCurrentSlideThumbnail(true));
                    this.props.dispatch(showZoomSlides(false));
                }
                break;
            }

            case 2: { // CANCEL
                this.props.dispatch(showZoomSlides(false));
                break;
            }
        }
    },
    isResetEnabled() {
        if (this.props.index != 1)
            return false;

        const state = storeManager.getState();
        const background = state.currentSlide.model.content[0];

        if (background.hotSpot != undefined && background.hotSpot != '')
            return true;
        else
            return false;
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        var iconColor;
        var buttonColor;
        var tabIndexValue;

        if (this.props.index == 0) {
            if (this.state.isOver == true) {
                iconColor = properties.CONTEXT_HOVER_COLOR;
                buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
            } else {
                iconColor = 'black';
                buttonColor = '#48A5E5';
            }
        } else
        if (this.props.index == 1 && this.isResetEnabled() == false) {
            iconColor = '#CFCFCF';
            buttonColor = '#EEEEEE';
            tabIndexValue = '-1';
        } else {
            if (this.state.isOver == true) {
                iconColor = properties.CONTEXT_HOVER_COLOR;
                buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
            } else {
                iconColor = 'black';
                buttonColor = '#DCDCDC';
            }
        }

        var topPosition =  5 + this.props.index * (properties.OBJECT_ADVANCED_BUTTON_HEIGHT + 5);

        const buttonStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: this.props.accordionWidth - properties.BROWSER_LEFT_PADDING,
            height: properties.OBJECT_ADVANCED_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: properties.BROWSER_LEFT_PADDING,
            top: topPosition,
            color: 'white',
            margin: 0,
            paddingTop: 0,
            paddingBottom: 0,
            paddingRight: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none'
        };

        const spanStyle = {
            color: iconColor,
            cursor: 'default',
            fontSize: 18,
            textAlign: 'center',
            width: buttonStyle.width
        };

        var buttonId;

        if (this.props.index == 0)
            buttonId = 'zoomMenuFirstFocusableElement';

        if (this.props.index == 2)
            buttonId = 'zoomMenuLastFocusableElement';

        return (
            <button id={buttonId} aria-label={this.props.text} tabIndex={tabIndexValue} aria-disabled={tabIndexValue == '-1' ? true : false} style={buttonStyle} onTouchEnd={this.onClick} onClick={this.onClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onKeyDown={this.onKeyDown}>
                <span style={spanStyle}>{this.props.text}</span>
            </button>
        );
    }
});

const ZoomMenuContent = React.createClass({
    componentWillReceiveProps() {
        if (platformDetection.isIOS())
            return;

        setTimeout(function() {
            var element = document.getElementById('zoomMenuFirstFocusableElement');

            if (element)
                element.focus();
        }.bind(this), 30);
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.windowHeight != newProps.windowHeight || this.props.accordionWidth != newProps.accordionWidth || this.props.showZoomSlides != newProps.showZoomSlides)
            return true;
        else
            return false;
    },
    render() {
        if (this.props.showZoomSlides == false)
            return (<div/>);

        const menuStyle = {
            position: 'absolute',
            top: apiServiceUtils.getNoInternetConnectionAlertHeight(),
            right: 0,
            width: this.props.accordionWidth,
            height: this.props.windowHeight,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white',
            zIndex: 20000
        };

        const buttonsHolderStyle = {
            position: 'absolute',
            top: properties.CLIPART_BUTTON_HEIGHT
        };

        return (
            <div style={menuStyle} id='zoomMenu'>
                <Title accordionWidth={this.props.accordionWidth}/>
                <div style={buttonsHolderStyle}>
                    <Button accordionWidth={this.props.accordionWidth} index={0} dispatch={this.props.dispatch} icon='fa fa-search' text={locales.getCaption('SetZoom', 'zoom')}/>
                    <Button accordionWidth={this.props.accordionWidth} index={1} dispatch={this.props.dispatch} icon='fa fa-trash-o' text={locales.getCaption('ResetZoom', 'zoom')}/>
                    <Button accordionWidth={this.props.accordionWidth} index={2} dispatch={this.props.dispatch} icon='fa fa-times-circle-o' text={locales.getCaption('Cancel', 'save')}/>
                </div>
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    var showZoomSlides = state.menu.showZoomSlides;

    if (showZoomSlides == undefined)
        showZoomSlides = false;

    return {
        showZoomSlides
    };
}

export const ZoomMenu = connect(mapStateToProps)(ZoomMenuContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/ZoomMenu.js
 **/